import { ref } from 'vue'

const shareLinkModalDisplayed = ref(false)
const shareLink = ref(null)

export {
  shareLink,
  shareLinkModalDisplayed,
}
